import styled, { css } from 'styled-components'
import styledBreakpoint from '@humblebee/styled-components-breakpoint'
import Theme from './theme'

const theme = new Theme()

export const breakpoint = styledBreakpoint({
  tablet: 768,
  desktop: 1024
})

export const H1Styles = css`
  font-family: ${theme.fontfamilySecondary};
  font-size: ${theme.fontSizeH1};
  line-height: ${theme.lineHeightH1};
  margin-bottom: ${theme.gutter};
  font-weight: 500;
`

export const H1 = styled.h1`
  ${H1Styles}
`
export const H2Styles = css`
  font-family: ${theme.fontfamilySecondary};
  font-size: ${theme.fontSizeH2};
  line-height: ${theme.lineHeightH2};
  margin-bottom: ${theme.gutter};
`
export const H2 = styled.h2`
  ${H2Styles}
`

export const H3Styles = css`
font-family: ${theme.fontfamilySecondary};
font-size: ${theme.fontSizeH3};
line-height: ${theme.lineHeightH3};
margin-bottom: ${theme.gutter};
`

export const H3 = styled.h3`
  ${H3Styles}
`

export const H4Styles = css`
  font-family: ${theme.fontfamilySecondary};
  font-size: ${theme.fontSizeH4};
  line-height: ${theme.lineHeightH4};
  margin-bottom: ${theme.gutter};
`

export const H4 = styled.h4`
  ${H4Styles}
`

export const FieldGroup = styled.article`
  margin-bottom: ${theme.gutter};
`

export const FieldRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  margin-bottom: ${theme.gutter};

  ${({ slim }) => slim && `
    margin-bottom: 0;
  `}

  ${({ large }) => large && `
    margin-bottom: ${theme.gutterMedium};
  `}

  ${({ columns }) => columns && `
    > * {
      width: calc(50% - 1rem);
    }
  `}
`

export const Actions = styled.article`
  margin-top: ${theme.gutterMedium};
  padding-bottom: ${theme.gutterLarge};
  text-align: right;
`
export const Instructions = styled.strong`
  margin-top: calc(${theme.gutterSmall} / 2);
  margin-left: ${theme.gutterSmall};
  font-size: ${theme.fontSizeSmall};
  color: ${theme.themeColorPrimaryOpacity};
  display: inline-block;
  font-weight: 400;
`

export const Required = styled.strong.attrs({
  title: 'Obligatoriskt fält'
})`
  position: absolute;
  right: ${theme.gutter};
  color: ${theme.themeColorError};
  font-size: 1em;
  top: 0.725em;
  cursor: help;

  ${({ inset }) => inset && `
    right: calc(${theme.gutter} * 2);
  `}

  ${({ inline }) => inline && `
    position: relative;
    right: auto;
    top: auto;
    display: inline-block;
    vertical-align: sub;
    line-height: 1;
    height: 0.5em;
    margin-left: ${theme.gutterSmall};
  `}
`

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;

  ${breakpoint.up('tablet')`
  margin-bottom: 0;
  ${({ half }) => half && `
    width: calc(50% - ${theme.gutter});
  `}

  ${({ third }) => third && `
    width: calc(33.33% - ${theme.gutter});
  `}
`}

`
export const HR = styled.hr`
  margin: ${theme.gutterMedium} 0;
`